module.exports = __webpack_public_path__ + "media/images/facebook-d714a0464d673590bc16ec72b56f33c7.svg";